// Adjective imports
import ageAdjectives from './wordlists/adjectives/age.txt'
import appearanceAdjectives from './wordlists/adjectives/appearance.txt'
import characterAdjectives from './wordlists/adjectives/character.txt'
import colorsAdjectives from './wordlists/adjectives/colors.txt'
import complexityAdjectives from './wordlists/adjectives/complexity.txt'
import emotionsAdjectives from './wordlists/adjectives/emotions.txt'
import foodAdjectives from './wordlists/adjectives/food.txt'
import materialsAdjectives from './wordlists/adjectives/materials.txt'
import quantityAdjectives from './wordlists/adjectives/quantity.txt'
import shapeAdjectives from './wordlists/adjectives/shape.txt'
import sizeAdjectives from './wordlists/adjectives/size.txt'
import soundAdjectives from './wordlists/adjectives/sound.txt'
import speedAdjectives from './wordlists/adjectives/speed.txt'
import tasteAdjectives from './wordlists/adjectives/taste.txt'
import temperatureAdjectives from './wordlists/adjectives/temperature.txt'
import weatherAdjectives from './wordlists/adjectives/weather.txt'

// Verb imports
import artVerbs from './wordlists/verbs/art.txt'
import collectionVerbs from './wordlists/verbs/collection.txt'
import communicationVerbs from './wordlists/verbs/communication.txt'
import cookingVerbs from './wordlists/verbs/cooking.txt'
import creationVerbs from './wordlists/verbs/creation.txt'
import destructionVerbs from './wordlists/verbs/destruction.txt'
import drivingVerbs from './wordlists/verbs/driving.txt'
import fireVerbs from './wordlists/verbs/fire.txt'
import lookVerbs from './wordlists/verbs/look.txt'
import manipulationVerbs from './wordlists/verbs/manipulation.txt'
import movementVerbs from './wordlists/verbs/movement.txt'
import musicVerbs from './wordlists/verbs/music.txt'
import sportsVerbs from './wordlists/verbs/sports.txt'
import thoughtVerbs from './wordlists/verbs/thought.txt'

// Noun imports
import apexPredatorsNouns from './wordlists/nouns/apex_predators.txt'
import automobilesNouns from './wordlists/nouns/automobiles.txt'
import birdsNouns from './wordlists/nouns/birds.txt'
import buildingsNouns from './wordlists/nouns/buildings.txt'
import carPartsNouns from './wordlists/nouns/car_parts.txt'
import catsNouns from './wordlists/nouns/cats.txt'
import cheeseNouns from './wordlists/nouns/cheese.txt'
import chemistryNouns from './wordlists/nouns/chemistry.txt'
import condimentsNouns from './wordlists/nouns/condiments.txt'
import containersNouns from './wordlists/nouns/containers.txt'
import corporateJobNouns from './wordlists/nouns/corporate_job.txt'
import cottonNouns from './wordlists/nouns/cotton.txt'
import designNouns from './wordlists/nouns/design.txt'
import dogsNouns from './wordlists/nouns/dogs.txt'
import drivingNouns from './wordlists/nouns/driving.txt'
import fastFoodNouns from './wordlists/nouns/fast_food.txt'
import filmmakingNouns from './wordlists/nouns/filmmaking.txt'
import fishNouns from './wordlists/nouns/fish.txt'
import foodNouns from './wordlists/nouns/food.txt'
import fortificationsNouns from './wordlists/nouns/fortifications.txt'
import fruitNouns from './wordlists/nouns/fruit.txt'
import furnitureNouns from './wordlists/nouns/furniture.txt'
import geographyNouns from './wordlists/nouns/geography.txt'
import geometryNouns from './wordlists/nouns/geometry.txt'
import ghostsNouns from './wordlists/nouns/ghosts.txt'
import historyNouns from './wordlists/nouns/history.txt'
import housesNouns from './wordlists/nouns/houses.txt'
import infrastructureNouns from './wordlists/nouns/infrastructure.txt'
import meatNouns from './wordlists/nouns/meat.txt'
import metalsNouns from './wordlists/nouns/metals.txt'
import musicInstrumentsNouns from './wordlists/nouns/music_instruments.txt'
import physicsNouns from './wordlists/nouns/physics.txt'
import physicsUnitsNouns from './wordlists/nouns/physics_units.txt'
import plantsNouns from './wordlists/nouns/plants.txt'
import seasoningsNouns from './wordlists/nouns/seasonings.txt'
import shoppingNouns from './wordlists/nouns/shopping.txt'
import spiritsNouns from './wordlists/nouns/spirits.txt'
import sportsNouns from './wordlists/nouns/sports.txt'
import storageNouns from './wordlists/nouns/storage.txt'
import travelNouns from './wordlists/nouns/travel.txt'
import waterNouns from './wordlists/nouns/water.txt'
import wineNouns from './wordlists/nouns/wine.txt'
import woodNouns from './wordlists/nouns/wood.txt'
import writingNouns from './wordlists/nouns/writing.txt'

import halloween from './specialDays/halloween.txt'
import christmas from './specialDays/christmas.txt'
export function getThemedWords() {
    return {
        // Adjectives
        ageAdjectives: parseWords(ageAdjectives),
        appearanceAdjectives: parseWords(appearanceAdjectives),
        characterAdjectives: parseWords(characterAdjectives),
        colorsAdjectives: parseWords(colorsAdjectives),
        complexityAdjectives: parseWords(complexityAdjectives),
        emotionsAdjectives: parseWords(emotionsAdjectives),
        foodAdjectives: parseWords(foodAdjectives),
        materialsAdjectives: parseWords(materialsAdjectives),
        quantityAdjectives: parseWords(quantityAdjectives),
        shapeAdjectives: parseWords(shapeAdjectives),
        sizeAdjectives: parseWords(sizeAdjectives),
        soundAdjectives: parseWords(soundAdjectives),
        speedAdjectives: parseWords(speedAdjectives),
        tasteAdjectives: parseWords(tasteAdjectives),
        temperatureAdjectives: parseWords(temperatureAdjectives),
        weatherAdjectives: parseWords(weatherAdjectives),

        // Verbs
        artVerbs: parseWords(artVerbs),
        collectionVerbs: parseWords(collectionVerbs),
        communicationVerbs: parseWords(communicationVerbs),
        cookingVerbs: parseWords(cookingVerbs),
        creationVerbs: parseWords(creationVerbs),
        destructionVerbs: parseWords(destructionVerbs),
        drivingVerbs: parseWords(drivingVerbs),
        fireVerbs: parseWords(fireVerbs),
        lookVerbs: parseWords(lookVerbs),
        manipulationVerbs: parseWords(manipulationVerbs),
        movementVerbs: parseWords(movementVerbs),
        musicVerbs: parseWords(musicVerbs),
        sportsVerbs: parseWords(sportsVerbs),
        thoughtVerbs: parseWords(thoughtVerbs),
        // Nouns
        apexPredatorsNouns: parseWords(apexPredatorsNouns),
        automobilesNouns: parseWords(automobilesNouns),
        birdsNouns: parseWords(birdsNouns),
        buildingsNouns: parseWords(buildingsNouns),
        carPartsNouns: parseWords(carPartsNouns),
        catsNouns: parseWords(catsNouns),
        cheeseNouns: parseWords(cheeseNouns),
        chemistryNouns: parseWords(chemistryNouns),
        condimentsNouns: parseWords(condimentsNouns),
        containersNouns: parseWords(containersNouns),
        corporateJobNouns: parseWords(corporateJobNouns),
        cottonNouns: parseWords(cottonNouns),
        designNouns: parseWords(designNouns),
        dogsNouns: parseWords(dogsNouns),
        drivingNouns: parseWords(drivingNouns),
        fastFoodNouns: parseWords(fastFoodNouns),
        filmmakingNouns: parseWords(filmmakingNouns),
        fishNouns: parseWords(fishNouns),
        foodNouns: parseWords(foodNouns),
        fortificationsNouns: parseWords(fortificationsNouns),
        fruitNouns: parseWords(fruitNouns),
        furnitureNouns: parseWords(furnitureNouns),
        geographyNouns: parseWords(geographyNouns),
        geometryNouns: parseWords(geometryNouns),
        ghostsNouns: parseWords(ghostsNouns),
        historyNouns: parseWords(historyNouns),
        housesNouns: parseWords(housesNouns),
        infrastructureNouns: parseWords(infrastructureNouns),
        meatNouns: parseWords(meatNouns),
        metalsNouns: parseWords(metalsNouns),
        musicInstrumentsNouns: parseWords(musicInstrumentsNouns),
        physicsNouns: parseWords(physicsNouns),
        physicsUnitsNouns: parseWords(physicsUnitsNouns),
        plantsNouns: parseWords(plantsNouns),
        seasoningsNouns: parseWords(seasoningsNouns),
        shoppingNouns: parseWords(shoppingNouns),
        spiritsNouns: parseWords(spiritsNouns),
        sportsNouns: parseWords(sportsNouns),
        storageNouns: parseWords(storageNouns),
        travelNouns: parseWords(travelNouns),
        waterNouns: parseWords(waterNouns),
        wineNouns: parseWords(wineNouns),
        woodNouns: parseWords(woodNouns),
        writingNouns: parseWords(writingNouns),
        //Days
        halloween: parseWords(halloween),
        christmas: parseWords(christmas),
    } as const
}
export type Theme = keyof ReturnType<typeof getThemedWords>
function parseWords(words: string) {
    return words.split('\n').map(w => w.trim()).filter(w => w.length > 0).filter(str => str.match(/^[a-z]+$/))
}

export const getRandomTheme = (): [string[], Theme] => {
    const themes = Object.entries(getThemedWords())
    const [theme, words] = themes[Math.floor(Math.random() * themes.length)]
    return [words, theme as Theme]
}

export const getTheme = (theme: Theme) => getThemedWords()[theme]